interface SwatchProps {
  color: string;
  selected: boolean;
  label?: string;
  onClick: () => void;
}

export function Swatch({ color, selected, label, onClick }: SwatchProps) {
  return (
    <button
      onClick={onClick}
      title={label ?? color}
      className="relative flex items-center justify-center"
      style={{ width: 44, height: 44, touchAction: 'manipulation' }}
    >
      <div
        className="rounded"
        style={{
          width: 32, height: 32,
          background: color,
          outline: selected ? '2px solid white' : '2px solid transparent',
          outlineOffset: 2,
        }}
      />
    </button>
  );
}
